import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import type { DashboardInfos } from '../types';
import { GET_INFOS_QUERY_KEY } from '@/_constants/keys';

type ParamsProps = {
  cityId: string;
};

const THIRTY_SECONDS = 30000;

const getDashboardInfos = (params: ParamsProps) => {
  const { cityId } = params;

  return apiClient
    .get<DashboardInfos>(`/utils/dashboard-infos/${cityId}`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetDashboardInfosData = Awaited<ReturnType<typeof getDashboardInfos>>;

export const useGetDashboardInfos = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetDashboardInfosData,
      unknown,
      GetDashboardInfosData,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_INFOS_QUERY_KEY, params],
    queryFn: () => getDashboardInfos(params),
    refetchIntervalInBackground: true,
    refetchInterval: THIRTY_SECONDS,
    ...options,
  });
};
